import {
  TaskCalendarCandidate,
  TaskCalendarDayTasks,
  TaskCalendarPlacement
} from '../models/task-calendar.model';

export abstract class TaskCalendarSyncRepository {
  abstract loadPlacements(startDate: string, endDate: string): Promise<TaskCalendarPlacement[]>;
  abstract searchOpenOccurrences(query: string, routineDate?: string): Promise<TaskCalendarCandidate[]>;
  abstract loadDateTasks(targetDate: string): Promise<TaskCalendarDayTasks>;
  abstract placeOccurrence(
    occurrenceId: number,
    calendarDate: string,
    axisId: number,
    position: number
  ): Promise<number>;
  abstract rescheduleOccurrence(occurrenceId: number, scheduledFor: string | null): Promise<void>;
  abstract deplanOccurrence(occurrenceId: number): Promise<boolean>;
  abstract setPlacementPosition(entryId: number, position: number): Promise<void>;
  abstract completeRoutineOccurrence(occurrenceId: number): Promise<void>;
  abstract setRoutineOccurrenceStatus(
    occurrenceId: number,
    status: 'COMPLETED' | 'NOT_RECORDED'
  ): Promise<void>;
}
